module.exports = __webpack_public_path__ + "static/media/purple1.1e0d843e.png";